import i18n from "../i18n";

const translation = language => i18n.getFixedT(language === "en" ? "en" : "de", "iflowDocumentationPdf");
export const DOCUMENTATION_SECTION_KEYS = Object.freeze(["change", "impact", "notes"]);

// One application-owned structure for the browser and PDF. The model supplies
// field contents, never headings, field order, metadata or diagram placement.
export function documentationSections(extension, language = "de") {
  const t = translation(language);
  if (extension.content == null) {
    return [{ key: "legacy", title: t("section.legacy"), markdown: extension.markdown || "" }];
  }
  const content = extension.content;
  if (content.schemaVersion !== 1 || Object.keys(content).length !== 4 ||
      DOCUMENTATION_SECTION_KEYS.some(key => typeof content[key] !== "string" || !content[key].trim())) {
    throw new Error(t("invalidExtension"));
  }
  return DOCUMENTATION_SECTION_KEYS.map(key => ({ key, title: t(`section.${key}`),
    markdown: key === "impact" && extension.analysisStatus === "failed"
      ? `${t("generation.phase.failed")}. ${t(`generation.reason.${extension.generationProgress?.reason || "generation"}`)} ${t("generation.stopped")}`
      : content[key] }));
}

export function orderedDocumentationExtensions(extensions = []) {
  const compareId = (a, b) => String(a.id || "") < String(b.id || "") ? -1 : String(a.id || "") > String(b.id || "") ? 1 : 0;
  return [...extensions].sort((a, b) =>
    (Date.parse(a.createdAt) || 0) - (Date.parse(b.createdAt) || 0) || compareId(a, b));
}

export function documentationExtensionFacts(extension, language = "de") {
  const t = translation(language), receipt = extension.transport?.receipt;
  return [
    extension.createdAt && `${t("recorded")}: ${extension.createdAt}`,
    (extension.sourceStage || extension.targetStage) && `${t("stages")}: ${extension.sourceStage || "?"} >> ${extension.targetStage || "?"}`,
    extension.transport?.runId && `${t("run")}: ${extension.transport.runId}`,
    extension.sourceSha && `${t("snapshot")}: ${extension.sourceSha}`,
    ...["upload", "configuration", "deployment"].filter(key => receipt?.[key]).map(key => `${t(key)}: ${t(`outcome.${receipt[key]}`, { defaultValue: receipt[key] })}`),
  ].filter(Boolean);
}
